import React, { useState } from 'react';
import { Modal, message } from 'antd';
import InvQuote from '../../../invoice/InvQuote';
import { useAuth } from '../../../../AuthProvider';
import { v4 as uuidv4 } from 'uuid';

const CreateInvoiceModal = ({ open, onClose, onCreated, transaction }) => {
  const auth = useAuth();
  // Pre-fill invoice with paid: 'Y' and transaction details
  const initialInvoice = {
    paid: 'Y',
    invoiceOrQuoteNumber: `I-${uuidv4().split('-')[0]}`,
    dated: transaction?.transactionDate,
    dueDate: transaction?.transactionDate,
    total: Math.abs(transaction?.amount || 0),
    grandTotal: Math.abs(transaction?.amount || 0),
    description: transaction?.description,
    // You can map more fields as needed
  };

  const handleSave = async (invoice) => {
    try {
      // Save invoice via backend (InvQuote handles this)
      onCreated(invoice); // Notify parent to mark as reconciled
      onClose();
      message.success('Invoice created and marked as paid!');
    } catch (e) {
      message.error('Failed to create invoice');
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      destroyOnClose
      title="Create Invoice for Transaction"
    >
      <InvQuote
        type="invoice"
        item={initialInvoice}
        onSave={handleSave}
        onCancel={onClose}
      />
    </Modal>
  );
};

export default CreateInvoiceModal;
